import { useMemo } from "react";

import { OrganizationRoles, Roles } from "@/shared/utils/constants";
import { InvitePermissions } from "@/features/organizations/profile/types";
import { UserInviteResponse } from "@/redux/invites/types";
import { FullUserResponse } from "@/redux/users/types";

export const useInvitePermissions = (
  invite: UserInviteResponse | null | undefined,
  currentUser: FullUserResponse | null | undefined,
): InvitePermissions => {
  const getCanDelete = (
    invite: UserInviteResponse | null | undefined,
    currentUser: FullUserResponse | null | undefined,
  ) => {
    if (invite && currentUser) {
      if (invite.role === OrganizationRoles.ADMIN.value) {
        return currentUser.organizationRole === OrganizationRoles.ADMIN.value;
      }
      return [
        OrganizationRoles.ADMIN.value,
        OrganizationRoles.SUPERVISOR.value,
      ].includes(currentUser.organizationRole);
    }
    return false;
  };

  return useMemo(() => {
    if (!currentUser) {
      return {
        canEdit: false,
        canDelete: false,
        canCreate: false,
      };
    }

    const isAppAdmin = currentUser.role === Roles.ADMIN.value;
    const isAdmin =
      currentUser.organizationRole === OrganizationRoles.ADMIN.value;
    const isSupervisor =
      currentUser.organizationRole === OrganizationRoles.SUPERVISOR.value;
    const isInviteOfOrganization =
      invite && invite.organization === currentUser.organization?.id;

    const canCreate = isAdmin || isSupervisor || isAppAdmin;
    const canEdit = Boolean(
      (isInviteOfOrganization && (isAdmin || isSupervisor)) || isAppAdmin,
    );
    const canDelete = getCanDelete(invite, currentUser) || isAppAdmin;

    return {
      canEdit,
      canDelete,
      canCreate,
    };
  }, [invite, currentUser]);
};
